import type { Api } from '../api.js';
import { toast } from '../ui.js';

/**
 * Opens a video's Ziflow review (owner 2026-10-24: Ziflow and the Hub side by side until 9 November): a personal one-time
 * link to the newest version, or the project's Ziflow folder. The tab opens before the request so the browser does not
 * block it.
 */
export async function openZiflow(api: Api, projectId: string, videoId: string, opening: string): Promise<void> {
  const w = window.open('', '_blank');
  if (w) {
    w.opener = null;
    try {
      w.document.title = opening;
      w.document.body.textContent = opening;
    } catch {
      // a browser that blocks access to the new tab still navigates it below
    }
  }
  try {
    const r = await api.post<{ url: string }>(`/api/projects/${projectId}/videos/${videoId}/ziflow`);
    if (w && !w.closed) w.location.href = r.url;
    else location.assign(r.url);
  } catch (e) {
    w?.close();
    toast({ text: e instanceof Error ? e.message : String(e) });
  }
}
